/* eslint-disable */
const olx =`<problem>
  <stringresponse type="ci">
    <additional_answer />
    <textline size="20"/>
  </stringresponse>
</problem>`

const markdown = `= the correct answer
or= optional acceptable variant of the correct answer
`

export default { olx, markdown };
